import React, { useCallback, useState } from 'react';
import { useMediaQuery } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { logout } from '../../features/auth/authSlice';

import './BurgerMenu.css';
import AppLogo from '@/assets/images/awardsapp_logo.webp'
import CButton from '../UI/CButton';
import CDialog from '../UI/CDialog';
import TaxReportForm from '../../containers/reporting/components/TaxReportForm';
import config from '../../config/env';

const BurgerMenu = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const isMobile = useMediaQuery('(max-width: 768px)');

    const [taxReportDialogOpen, setTaxReportDialogOpen] = useState(false);

    const NAVIGATION_ACTIONS = {
        PROFILE: '/profile',
        ACCOUNT: '/account',
        USERS: '/users',
        REPORTING: config.REPORTING_URL,
        TAX_REPORT: '/tax-report',
        SIGNOUT: 'SignOut',
    };

    const handleMenuItemClick = useCallback((location) => {
        return () => navigate(location);
    }, [navigate]);

    const handleLogout = () => {
        dispatch(logout())
    }

    return (
        <div className="burger-menu">
            <div className="burger-menu-container">

                <img
                    src={AppLogo}
                    alt="awardsapp logo"
                    className="awardsapp-logo"
                    fetchpriority="high"
                    width="200"
                    height="36"
                />

                <div className="divider"></div>

                {/* Menu actions */}
                <div className="menu-entry-items">
                    <CButton
                        className={`profile-button${location.pathname === NAVIGATION_ACTIONS.PROFILE ? ' active' : ''}`}
                        type="submit"
                        variant="text"
                        size="large"
                        fullWidth
                        leftIcon={"user-profile-setting"}
                        rightIcon={location.pathname === NAVIGATION_ACTIONS.PROFILE ? "arrow-right" : ""}
                        onClick={handleMenuItemClick(NAVIGATION_ACTIONS.PROFILE)}
                        colorTheme="primary"
                        label="Profile"
                        alignment="left"
                    />

                    <CButton
                        className={`account-button${location.pathname === NAVIGATION_ACTIONS.ACCOUNT ? ' active' : ''}`}
                        type="submit"
                        variant="text"
                        size="large"
                        fullWidth
                        leftIcon={"money-wallet"}
                        rightIcon={location.pathname === NAVIGATION_ACTIONS.ACCOUNT ? "arrow-right" : ""}
                        onClick={handleMenuItemClick(NAVIGATION_ACTIONS.ACCOUNT)}
                        colorTheme="primary"
                        label="Account"
                        alignment="left"
                    />

                    <CButton
                        className={`users-button${location.pathname === NAVIGATION_ACTIONS.USERS ? ' active' : ''}`}
                        type="submit"
                        variant="text"
                        size="large"
                        fullWidth
                        leftIcon={"app-window-user"}
                        rightIcon={location.pathname === NAVIGATION_ACTIONS.USERS ? "arrow-right" : ""}
                        onClick={handleMenuItemClick(NAVIGATION_ACTIONS.USERS)}
                        colorTheme="primary"
                        label="Users"
                        alignment="left"
                    />

                    {import.meta.env.MODE !== 'production' && (
                        <CButton
                            className="reporting-button"
                            type="button"
                            variant="text"
                            size="large"
                            fullWidth
                            leftIcon={"analytics-bars"}
                            onClick={() => window.open(NAVIGATION_ACTIONS.REPORTING, '_blank', 'noopener,noreferrer')}
                            colorTheme="primary"
                            label="Reporting"
                            alignment="left"
                        />
                    )}

                    <CButton
                        className={`tax-report-button${location.pathname === NAVIGATION_ACTIONS.TAX_REPORT ? ' active' : ''}`}
                        type="button"
                        variant="text"
                        size="large"
                        fullWidth
                        leftIcon={"tax-report"}
                        onClick={() => setTaxReportDialogOpen(true)}
                        colorTheme="primary"
                        label="Earnings Report"
                        alignment="left"
                    />
                </div>

                <div className="divider"></div>

                {/* Logout */}
                <div className="sign-out-entry">
                    <CButton
                        className="sign-out-button"
                        type="submit"
                        variant="outlined"
                        size="large"
                        fullWidth
                        rightIcon={'sign-out'}
                        onClick={handleLogout}
                        colorTheme="primary"
                        label="Log Out"
                    />
                </div>

                <div className="menu-footer">
                    <p className="footer-text text-6">Powered by Achievement Awards Group (PTY) Ltd</p>
                </div>
            </div>

            {/* Tax Report Dialog */}
            <CDialog
                open={taxReportDialogOpen}
                onClose={() => setTaxReportDialogOpen(false)}
                title="Earnings Report"
                titleIcon="tax-report"
                maxWidth="xs"
                fullWidth
            >
                <TaxReportForm
                    onClose={() => setTaxReportDialogOpen(false)}
                    onSuccess={() => setTaxReportDialogOpen(false)}
                />
            </CDialog>
        </div>
    );
}

export default React.memo(BurgerMenu);